import { ThalesSpecialConf } from './Thales';
import { RCSpecialConf } from './RC';
import { TandemzSpecialConf } from './Tandemz';
import { LegalstartSpecialConf } from './Legalstart';
import { Freebox } from './Freebox';
import { DinumSpecialConf } from './Dinum';
import { LuccaSpecialConf } from './Lucca';

type SpecialConf = {
  orgId: string;
  panelId?: string;
  specialFields: Array<{
    name: string;
    accessor?: string | Function;
    clientLabel: string;
    participantLabel: string;
    formComponent: any;
  }>;
};
export const clientSpecialConfigs: SpecialConf[] = [
  ThalesSpecialConf,
  RCSpecialConf,
  TandemzSpecialConf,
  LegalstartSpecialConf,
  Freebox,
  DinumSpecialConf,
  LuccaSpecialConf,
];
